import React, { memo } from 'react';
import classNames from 'classnames';
import { useTranslate } from '@tolgee/react';
import { EAuthVarient } from '@/types/Authentication';
import { useStore } from '@/zustand/store/store';
import { Typography } from '../Atoms';
import LoginSvg from '../Svg/LoginSvg';
import style from './CommandCenter.module.scss';

const LoginSection = (props: { isHorizontal?: boolean }) => {
  const { t } = useTranslate('commandCenter');
  const { isHorizontal } = props;
  const { setAuthModalVarient } = useStore();
  return (
    <div className={classNames('w-full h-full text-center flex items-center justify-center gap-x-[2px] mt-1', !isHorizontal && 'flex-col')}>
      <LoginSvg />
      <Typography className={!isHorizontal && 'mt-1'} size='s12ToS12'>
        {t('CENTER_SECTION.myStateSection.notLogin')}
      </Typography>
      <Typography size='s12ToS12'>
        {t('CENTER_SECTION.myStateSection.notLoginDesc')}{' '}
        <Typography
          size='s12ToS12'
          className={classNames(
            style.hoverAnimation,
            'text-[#06BFB4] cursor-pointer', // Conditionally add another class if needed
          )}
          isBold
          onClick={() => setAuthModalVarient(EAuthVarient.SIGN_IN)}
        >
          {t('CENTER_SECTION.myStateSection.loginHighlight')}
        </Typography>{' '}
      </Typography>
    </div>
  );
};

export default memo(LoginSection);
